// extracted by mini-css-extract-plugin
export default {"positionRelative":"tableEditButtons_positionRelative__TBzjg","cancelButton":"tableEditButtons_cancelButton__Ce6ho","isReverted":"tableEditButtons_isReverted__N3f8c"};